import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, input, output, ViewChild } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { SdDialog } from '@solid-design-system/components/dist-versioned';
import { Dialog } from 'src/app/common/util/dialog';

@Component({
  selector: 'app-delete-filter-template-dialog',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, TranslocoModule],
  templateUrl: './delete-filter-template-dialog.component.html',
  styleUrl: './delete-filter-template-dialog.component.scss',
})
export class DeleteFilterTemplateDialogComponent extends Dialog {
  readonly headline = 'dashboard.sidepanel.deleteTemplate.dialog.title';
  readonly message = 'dashboard.sidepanel.deleteTemplate.dialog.message';
  readonly nameLabel = 'dashboard.sidepanel.deleteTemplate.dialog.name';
  readonly cancelLabel = 'dashboard.sidepanel.deleteTemplate.dialog.cancel';
  readonly confirmLabel = 'dashboard.sidepanel.deleteTemplate.dialog.confirm';

  /** The id of the template that is being deleted. */
  public readonly templateId = input<string>();

  /** The name of the template that is being deleted. */
  public readonly templateName = input<string>('');

  /** Emits when the user confirms the deletion. */
  public readonly confirmed = output<void>();

  /** Emits when the user cancels the dialog. */
  public readonly cancelled = output<void>();

  @ViewChild('dialog')
  private readonly dialog!: ElementRef<SdDialog>;

  cancel(): void {
    this.cancelled.emit();
  }

  confirm(): void {
    this.confirmed.emit();
    this.dialog?.nativeElement?.hide();
  }

  open(): void {
    this.dialog?.nativeElement?.show();
  }
}

